/* Yoopy – upsell v košíku s variantmi (bez prekliku na produkt). 20/10/26 v4 (pôvodný vzhľad košíka)
   – produkt bez variantov: tlačidlo „Pridať do košíka" (rieši yoopy-gift.js),
   – produkt s variantmi: tlačidlo „Vybrať" rozbalí zoznam variantov; klik na variant ho rovno pridá
     (každý variant je button[data-yg-add] → /cart/add.js v yoopy-gift.js, košík ostáva otvorený). */
(function () {
  "use strict";
  if (window.__ygUpVariants) return;
  window.__ygUpVariants = 4;

  // Len štýly potrebné pre funkčnosť (šípka pri „Vybrať", zoznam variantov) – vzhľad košíka ostáva podľa témy
  var st = document.createElement("style");
  st.id = "yg-up-variants-css";
  st.textContent =
    ".yg-up-toggle{display:inline-flex!important;align-items:center;justify-content:center;gap:6px}.yg-up-toggle svg{width:14px;height:14px;flex:0 0 auto;transition:transform .2s ease;stroke:currentColor;fill:none;stroke-width:2.4;stroke-linecap:round;stroke-linejoin:round}.yg-up-toggle[aria-expanded=true]{background:#5D489B!important;border-color:#5D489B!important;color:#fff!important}.yg-up-toggle[aria-expanded=true] svg{transform:rotate(180deg)}.yg-up-vars{display:flex;flex-direction:column;gap:6px;margin-top:10px;max-height:228px;overflow-y:auto;padding:2px;animation:ygVarsIn .18s ease}.yg-up-vars[hidden]{display:none}@keyframes ygVarsIn{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}.yg-up-var{display:flex;align-items:center;gap:10px;width:100%;text-align:left;background:#fff;border:1.5px solid #e4def0;border-radius:14px;padding:9px 10px 9px 14px;font:inherit;color:#2b2540;cursor:pointer;transition:border-color .15s,background .15s,box-shadow .15s}.yg-up-var:hover,.yg-up-var:focus-visible{border-color:#5D489B;background:#faf8fd;box-shadow:0 2px 8px rgba(93,72,155,.12);outline:none}.yg-up-var:disabled{opacity:.6;cursor:wait}.yg-up-var-name{flex:1 1 auto;min-width:0;font-size:13px;font-weight:600;line-height:1.3}.yg-up-var-price{flex:0 0 auto;font-size:13px;white-space:nowrap;text-align:right;line-height:1.25}.yg-up-var-price s{display:block;font-size:11px;color:#9a93ad;font-weight:400}.yg-up-var-plus{flex:0 0 26px;width:26px;height:26px;border-radius:50%;background:#5D489B;color:#fff;display:flex;align-items:center;justify-content:center;transition:transform .15s}.yg-up-var-plus svg{width:14px;height:14px;stroke:#fff;fill:none;stroke-width:2.6;stroke-linecap:round}.yg-up-var:hover .yg-up-var-plus{transform:scale(1.08);background:#4a3880}.yg-up-var.is-adding{justify-content:center;font-weight:600;color:#5D489B}";
  document.head.appendChild(st);

  var CHEV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>',
    PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    cache = {},
    uid = 0;

  function D() {
    return window.YoopyGift || {};
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function cents(v) {
    return typeof v == "number" ? v : Math.round(parseFloat(v || 0) * 100);
  }
  function money(c) {
    var d = D(),
      cur = d.currency || "€",
      whole = cur === "Kč" || cur === "Ft",
      dec = d.decimals != null ? d.decimals : whole ? 0 : 2;
    return (c / 100).toLocaleString(d.locale || "sk-SK", { minimumFractionDigits: dec, maximumFractionDigits: dec }) + "\xA0" + cur;
  }
  function handleOf(href) {
    var m = String(href || "").match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function product(h) {
    if (!cache[h])
      cache[h] = fetch("/products/" + encodeURIComponent(h) + ".js", { headers: { Accept: "application/json" } }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      });
    return cache[h];
  }

  async function enhance(a) {
    a.setAttribute("data-yg-done", "1");
    var h = handleOf(a.getAttribute("href"));
    if (!h) return;
    var p;
    try {
      p = await product(h);
    } catch (e) {
      delete cache[h];
      return;
    }
    var av = (p.variants || []).filter(function (v) {
      return v.available;
    });
    if (!av.length || !a.isConnected) return;

    var btn = document.createElement("button"),
      panel = document.createElement("div"),
      id = "yg-up-vars-" + ++uid;
    btn.type = "button";
    btn.className = a.className + " yg-up-toggle";
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-controls", id);
    btn.innerHTML = "<span>" + esc(a.textContent.trim() || (D().texts || {}).upsellChoose || "Vybrať") + "</span>" + CHEV;

    panel.className = "yg-up-vars";
    panel.id = id;
    panel.hidden = true;
    panel.innerHTML = av
      .map(function (v) {
        var pr = cents(v.price),
          cp = cents(v.compare_at_price);
        return (
          '<button type="button" class="yg-up-var" data-yg-add="' +
          v.id +
          '" aria-label="' +
          esc((D().texts || {}).upsellAdd || "") +
          " " +
          esc(p.title + " – " + (v.public_title || v.title)) +
          '"><span class="yg-up-var-name">' +
          esc(v.public_title || v.title) +
          '</span><span class="yg-up-var-price"><strong>' +
          money(pr) +
          "</strong>" +
          (cp > pr ? "<s>" + money(cp) + "</s>" : "") +
          '</span><span class="yg-up-var-plus">' +
          PLUS +
          "</span></button>"
        );
      })
      .join("");

    a.replaceWith(btn);
    btn.insertAdjacentElement("afterend", panel);
  }

  // Rozbalenie / zbalenie (vždy len jeden otvorený)
  document.addEventListener("click", function (e) {
    var t = e.target.closest(".yg-up-toggle");
    if (t) {
      e.preventDefault();
      var open = t.getAttribute("aria-expanded") !== "true";
      document.querySelectorAll(".yg-up-toggle[aria-expanded=true]").forEach(function (o) {
        if (o === t) return;
        o.setAttribute("aria-expanded", "false");
        var op = document.getElementById(o.getAttribute("aria-controls"));
        op && (op.hidden = true);
      });
      t.setAttribute("aria-expanded", open ? "true" : "false");
      var pn = document.getElementById(t.getAttribute("aria-controls"));
      if (pn) {
        pn.hidden = !open;
        open && pn.scrollIntoView({ block: "nearest", behavior: "smooth" });
      }
      return;
    }
    // Stav „pridávam" na variante – samotné pridanie spraví yoopy-gift.js
    var v = e.target.closest(".yg-up-var");
    if (v) {
      v.classList.add("is-adding");
      setTimeout(function () {
        v.disabled = true;
      }, 0);
    }
  }, true);

  // Zmena variantu položky v košíku (.cart-variant-switcher): úvodná voľba „Zmeniť variant"
  // je len popis – nedá sa späť vybrať (inak Shopify vráti chybu „Required parameter missing or invalid: id").
  function isId(v) {
    return /^\d+$/.test(String(v || ""));
  }
  function lockSwitchers() {
    document.querySelectorAll(".cart-variant-switcher select:not([data-yg-lock])").forEach(function (s) {
      s.setAttribute("data-yg-lock", "1");
      Array.prototype.forEach.call(s.options, function (o) {
        if (!isId(o.value)) {
          o.disabled = true;
          o.hidden = true;
        }
      });
    });
  }
  document.addEventListener(
    "change",
    function (e) {
      var s = e.target;
      if (s && s.matches && s.matches(".cart-variant-switcher select") && !isId(s.value)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true,
  );

  function scan() {
    lockSwitchers();
    document.querySelectorAll(".yg-upsell a.yg-up-btn:not([data-yg-done])").forEach(enhance);
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", scan) : scan();
})();
